import React from 'react';
import { arrayOf, bool, func, node, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import { IconReview, IconTrustpilot } from '../../../../components';
import SectionContainer from '../SectionContainer';
import css from './SectionCtas.module.css';

import checklistIllustration from './images/checklistIllustration.svg';

// Section component that's able to show blocks in multiple different columns (defined by "numColumns" prop)
const SectionCtas = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const secondaryCtaData = {
    fieldType: 'internalButtonLink',
    href: '/s',
    content: 'Jetzt starten',
  };

  return (
    <div className={css.mainContainer}>
      <SectionContainer
        id={sectionId}
        className={classNames(className, css.container)}
        rootClassName={rootClassName}
        appearance={appearance}
        options={fieldOptions}
      >
        {hasHeaderFields ? (
          <header className={classNames(css.sectionDetails, defaultClasses.sectionDetails)}>
            <img
              className={css.checklistIllustration}
              src={checklistIllustration}
              alt="checklist"
            />
            <Field
              data={title}
              className={classNames(css.title, defaultClasses.title)}
              options={fieldOptions}
            />
            <Field
              data={description}
              className={classNames(css.description, defaultClasses.description)}
              options={fieldOptions}
            />
            <div className={css.reviewWrapper}>
              <div className={css.rating}>
                <div className={css.ratingTitle}>
                  Ausgezeichnet
                  <span title={`${5}/5`}>
                    {[1, 2, 3, 4, 5].map(star => (
                      <IconReview
                        key={`star-${star}`}
                        className={css.reviewRatingStar}
                        isFilled={star <= 5}
                      />
                    ))}
                  </span>
                </div>

                <div className={css.ratingCount}>
                  {intl.formatMessage(
                    { id: 'LandingPage.SectionReviews.count' },
                    { count: <span>{266}</span> }
                  )}
                </div>
                <div className={css.trustpilot}>
                  <IconTrustpilot />
                  <span>{intl.formatMessage({ id: 'LandingPage.SectionReviews.trustpilot' })}</span>
                </div>
              </div>
            </div>
            <div className={css.ctaContainer}>
              <Field
                data={callToAction}
                className={classNames(defaultClasses.ctaButton, css.ctaButton)}
                options={fieldOptions}
              />
              <Field
                data={secondaryCtaData}
                className={classNames(defaultClasses.ctaButton, css.ctaButton, css.secondaryCta)}
                options={fieldOptions}
              />
            </div>
          </header>
        ) : null}
      </SectionContainer>
    </div>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionCtas.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  numColumns: 1,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  blocks: [],
  isInsideContainer: false,
  options: null,
};

SectionCtas.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  numColumns: number,
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  blocks: arrayOf(object),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionCtas;
